module.exports = __webpack_public_path__ + "img/Group21@2x.1df18d08.png";